import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: number;
  title: string;

  // Titles
  field_common_malay_title: string;
  field_common_mandarin_title: string;

  // Body & Descriptions
  body: string;
  field_common_malay_description: string;
  field_common_mandarin_descriptio?: string;

  // Category & Brand
  field_category: string;
  category: string;
  subCategory: string;
  brand: string;

  // Images
  field_product_image: string;
  image: string[];

  // Flags
  dutyFree: boolean;
  field_new_arrival: boolean;
  field_best_seller: boolean;
  field_promotions: boolean;

  // Prices
  field_original_price: number;
  field_old_price?: string | null;
  field_product_offer?: string | null;
  oldPrice: number;
  price: number;
  productOffer: number;

  // Codes
  productCode: number;

  // Promotions
  field_promotion_title?: string;
  field_malay_promotion_title?: string;
  field_mandarin_promotion_title?: string;

  // Status & Metadata
  level: string;
  field_created_date?: string;
  field_updated_date?: string;
  field_products_published?: string;
  createdAt: string;
  updatedAt: string;
  status: string | boolean; // API sends "True"/"False"

  // Exports (Multi-select)
  field_store_location_export: string[];
  field_airport_export: string[];

  // Terms & Conditions
  field_product_terms_conditions: string;
  field_malay_terms_and_conditions: string;
  field_mandarin_terms_and_conditi: string;
}

// edit api call
const fetchProductsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/productsid/${id}`);
  console.log("fetchProductsDetails", response);
  return response.data[0];
};

const useProductsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["productsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchProductsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useProductsDocumentDetails };
